import { MONTHS } from "lib/constants";

export const calculateMonthlyData = (
    data: DataEntry[],
    valueKey: "revenue" | "bookings" | "subscriptions"
  ): MonthlyDataResult => {
    const monthlyMap: Record<string, number> = {};
  
    data.forEach((entry) => {
      const monthIndex = new Date(entry.date).getMonth(); 
  const key = entry[valueKey];
  
      if (key != null) {
        monthlyMap[MONTHS[monthIndex]] = (monthlyMap[MONTHS[monthIndex]] || 0) + key;
      }
    });
  
    const monthlyData = MONTHS.map((month) => monthlyMap[month] || 0);
  
    const maxValue = Math.max(...monthlyData);
    
    const yAxisMax = Math.ceil((maxValue + 1) / 5) * 5;
  
    return { monthlyData, yAxisMax };
  };